import { superToggle } from "./helpers/super-toggle";

window.addEventListener('load', () => {
    let offCanvasMenu = document.getElementById('offCanvasMenu');
    let menuToggles = document.querySelectorAll('.menu-toggle');

    let scrollLimit = 250;
    let navOpenScrollPosY = window.scrollY;
    let siteHeader = document.getElementById('siteHeader');

    let offCanvasMenuDirectionsToggle = document.getElementById('offCanvasMenuDirectionsToggle');
    let offCanvasMenuDirections = document.getElementById('offCanvasMenuDirections');
    let svgToggles = offCanvasMenuDirectionsToggle ? offCanvasMenuDirectionsToggle.querySelectorAll('.svg-toggle') : [];

    for (let menuToggle of menuToggles) {
        if (offCanvasMenu && menuToggle) {
            offCanvasMenu.removeAttribute('style');
            menuToggle.addEventListener('click', () => {
                navOpenScrollPosY = window.scrollY;
                startListening();
                offCanvasMenu.classList.remove('translate-x-full');
                for (let menuToggle of menuToggles) {
                    menuToggle.classList.add('nav-active');
                }
            });
        }
    }

    if (offCanvasMenu && offCanvasMenuDirectionsToggle && offCanvasMenuDirections) {
        offCanvasMenuDirectionsToggle.addEventListener('click', () => {
            offCanvasMenuDirections.classList.toggle('-translate-x-full');
            offCanvasMenuDirectionsToggle.classList.toggle('!bg-gray-brand');
            for (let svgToggle of svgToggles) {
                svgToggle.classList.toggle('opacity-0');
            }
        });
    }

    function closeMobileNav() {
        if (!offCanvasMenu.classList.contains('translate-x-full')) {
            offCanvasMenu.classList.add('translate-x-full');
            if (offCanvasMenuDirections) {
                offCanvasMenuDirections.classList.remove('-translate-x-full');
            }

            for (let menuToggle of menuToggles) {
                menuToggle.classList.remove('nav-active');
            }
            for (let svgToggle of svgToggles) {
                if (svgToggle.classList.contains('cross')) {
                    svgToggle.classList.add('opacity-0');
                    offCanvasMenuDirectionsToggle.classList.remove('!bg-gray-brand');
                } else {
                    svgToggle.classList.remove('opacity-0');
                }
            }
        }
    }

    // closes open menus and resets nav to default state
    function closeAllNavs() {
        closeMobileNav();
    }

    function startListening() {
        window.addEventListener('click', clickListener);
        window.addEventListener('resize', resizeListener);
        window.addEventListener('scroll', scrollListener);
    }

    function stopListening() {
        window.addEventListener('click', clickListener);
        window.removeEventListener('resize', resizeListener);
        window.removeEventListener('scroll', scrollListener);
    }

    // Throttle for resize listener to close open menus on page resize
    const closeNavResizeThrottle = _throttle(resizeCloseNav, 50, {leading: true, trailing: true});

    function resizeCloseNav() {
        let windowSize = window.innerWidth;
        const checkWidth = setTimeout(() => {
            if (windowSize !== window.innerWidth) {
                closeAllNavs();
                stopListening();
            }
            clearTimeout(checkWidth);
        }, 50);
    }

    // Debounce for click listener to close open menus if click is not inside menu
    const closeNavClickDebounce = _debounce(clickOutsideCloseNav, 50, {leading: true, trailing: true});

    function clickOutsideCloseNav() {
        if ((!document.getElementById('offCanvasMenu').contains(event.target) && !document.getElementById('offCanvasMenuOpen').contains(event.target)) || document.getElementById('offCanvasMenuClose').contains(event.target)) {
            closeAllNavs();
            stopListening();
        }
    }

    // Throttle for scroll listener to close open menus if scroll exceeded scroll limit
    const closeNavScrollThrottle = _throttle(scrolledPastLimit, 50, {leading: true, trailing: true});

    function scrolledPastLimit() {
        if (window.scrollY >= (scrollLimit + navOpenScrollPosY) || window.scrollY <= (navOpenScrollPosY - scrollLimit)) {
            closeAllNavs();
            stopListening();
        }
    }

    const clickListener = () => {
        closeNavClickDebounce(event);
    };

    const resizeListener = () => {
        closeNavResizeThrottle();
    };

    const scrollListener = () => {
        closeNavScrollThrottle();
    };

    // Throttle for scroll listener to adjust nav position based on scroll
    const throttleNavScrollCheck =  _throttle(navScrollCheck, 50, {leading: true, trailing: false});
    window.addEventListener('scroll', throttleNavScrollCheck, {passive: true});

    let scrollPositive = window.scrollY + scrollLimit;
    const delayedSet = setTimeout(() => {
        scrollPositive = window.scrollY + scrollLimit;
    }, 100);

    function navScrollCheck() {
        let scrollPos = window.scrollY;
        const checkScrollPos = setTimeout(() => {
            if (scrollPos > window.scrollY) {
                setNavStyles(true);
                scrollPositive = scrollPos + scrollLimit;
            } else if (scrollPos < window.scrollY) {
                if (scrollPositive < scrollPos) {
                    scrollPositive = scrollPos + scrollLimit;
                    setNavStyles(false);
                }
            }
            clearTimeout(checkScrollPos);
        }, 50);
    }

    // set nav position on load
    setNavStyles(true);

    // set nav pos / styles based on scrolling
    function setNavStyles(negScroll) {
        if (window.scrollY > scrollLimit && !negScroll) {
            siteHeader.classList.add('!fixed', '!-top-24', 'md:!-top-28');
            siteHeader.classList.remove('translate-y-full');
        } else if (window.scrollY > scrollLimit && negScroll) {
            siteHeader.classList.add('!fixed', '!-top-24', 'md:!-top-28', 'translate-y-full');
        } else {
            siteHeader.classList.add('!fixed', '!-top-24', 'md:!-top-28', 'translate-y-full');
        }
    }
});